import { AuthApiService } from '@services/auth.api.service';
import { JWTService } from '@services/jwt.service';

import {
  SET_AUTH,
  SET_TOKEN,
  SET_RETURN_URL,
  GENERATE_TOKEN_FROM_URL,
  LOGIN,
  LOGOUT,
} from '@store/modules/auth.types';
import { APP_NAMESPACE } from '@store/modules/app.types';
import { LOCATIONS_NAMESPACE } from '@store/modules/locations.types';

const generateDefaultUMSReturnUrlWithLocationSuffix = suffix => (
  `${window.location.origin}/?suffix=${suffix || ''}`
);

export default {
  namespaced: true,

  state: {
    token: JWTService.getToken(),
    isAuthenticated: false,
    returnUrl: null,
  },

  mutations: {
    [SET_AUTH](state, payload) {
      state.isAuthenticated = payload;
    },
    [SET_TOKEN](state, payload) {
      state.token = payload;
      if (payload) {
        JWTService.setToken(payload);
      } else {
        JWTService.removeToken();
      }
    },
    [SET_RETURN_URL](state, payload) {
      state.returnUrl = payload;
    },
  },

  actions: {
    async [GENERATE_TOKEN_FROM_URL](
      { state: { token: TOKEN }, commit, dispatch },
      { query },
    ) {
      const q = JSON.parse(JSON.stringify(query));
      const { umToken: UM_TOKEN } = q;

      if (!UM_TOKEN && !TOKEN) {
        dispatch(LOGOUT, { routeName: 'login' });
        return Promise.reject();
      }

      JWTService.setToken(UM_TOKEN || TOKEN);

      await AuthApiService.checkUserAuth();

      commit(SET_AUTH, true);

      if (UM_TOKEN) {
        commit(SET_TOKEN, UM_TOKEN);

        delete q.umToken;
        delete q.expires;
      }

      return Promise.resolve(q);
    },

    [LOGIN]({
      state: { returnUrl },
      rootState: {
        [APP_NAMESPACE]: { userManagerUrl, clientId },
        [LOCATIONS_NAMESPACE]: { suffix },
      },
    }) {
      window.location = `${
        userManagerUrl
      }/OuterAccount/Login?service=${
        clientId
      }&returnUrl=${
        encodeURIComponent(
          returnUrl || generateDefaultUMSReturnUrlWithLocationSuffix(suffix),
        )
      }`;
    },

    [LOGOUT]({ commit }, { routeName } = {}) {
      commit(SET_TOKEN, null);
      commit(SET_AUTH, false);

      if (routeName !== 'login' && routeName !== 'forbidden') {
        commit(SET_RETURN_URL, window.location.href);
      }
    },
  },
};
